<script>
import ExportJobService from '@src/services/ExportJobService'
import {
    buildExportJobTimeoutPatches,
    isExportJobPollingCandidate,
} from '@src/utils/exportJobTimeout'

const POLL_MS = 5000

export default {
    data() {
        return {
            exportJobPollTimer: null,
            exportJobPollInFlight: false,
        }
    },
    mounted() {
        this.exportJobOnVisibilityHandler = () => {
            if (!document.hidden) {
                this.ensureExportJobPolling()
            }
        }
        document.addEventListener(
            'visibilitychange',
            this.exportJobOnVisibilityHandler
        )
    },
    beforeDestroy() {
        this.clearExportJobPolling()
        if (this.exportJobOnVisibilityHandler) {
            document.removeEventListener(
                'visibilitychange',
                this.exportJobOnVisibilityHandler
            )
            this.exportJobOnVisibilityHandler = null
        }
    },
    methods: {
        exportJobIsInProgress(row) {
            return isExportJobPollingCandidate(row)
        },

        applyExportJobTimeoutPatches() {
            const rows = this.getExportJobsTableRows()
            const patches = buildExportJobTimeoutPatches(rows)
            if (patches.length === 0) {
                return
            }
            const wrapper = this.$refs.vuetable
            if (wrapper && typeof wrapper.patchTableRows === 'function') {
                wrapper.patchTableRows(patches)
            }
        },

        getExportJobsTableRows() {
            const wrapper = this.$refs.vuetable
            if (!wrapper || typeof wrapper.getTableRows !== 'function') {
                return []
            }
            return wrapper.getTableRows()
        },

        clearExportJobPolling() {
            if (this.exportJobPollTimer) {
                clearInterval(this.exportJobPollTimer)
                this.exportJobPollTimer = null
            }
        },

        ensureExportJobPolling() {
            this.$nextTick(() => {
                this.applyExportJobTimeoutPatches()
                const rows = this.getExportJobsTableRows()
                const hasInProgress = rows.some((r) =>
                    this.exportJobIsInProgress(r)
                )
                if (hasInProgress) {
                    if (!this.exportJobPollTimer) {
                        this.pollExportJobProgressOnce()
                        this.exportJobPollTimer = setInterval(
                            () => this.pollExportJobProgressOnce(),
                            POLL_MS
                        )
                    }
                } else {
                    this.clearExportJobPolling()
                }
            })
        },

        async pollExportJobProgressOnce() {
            if (document.hidden || this.exportJobPollInFlight) {
                return
            }
            this.applyExportJobTimeoutPatches()
            const rows = this.getExportJobsTableRows()
            const ids = rows
                .filter((r) => this.exportJobIsInProgress(r))
                .map((r) => r.id)
            if (ids.length === 0) {
                this.clearExportJobPolling()
                return
            }
            const payload = {
                ids,
                ...this.additionalParameters,
            }
            this.exportJobPollInFlight = true
            try {
                const res = await ExportJobService.fetchExportJobProgress(
                    payload
                )
                const list = res.data && res.data.data
                const wrapper = this.$refs.vuetable
                if (
                    list &&
                    Array.isArray(list) &&
                    wrapper &&
                    typeof wrapper.patchTableRows === 'function'
                ) {
                    wrapper.patchTableRows(list)
                }
            } catch (e) {
                // Polling is best-effort; avoid breaking the page on network errors.
            } finally {
                this.exportJobPollInFlight = false
                this.ensureExportJobPolling()
            }
        },
    },
}
</script>
